import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingWorkplacesSelector = createSelector(
  [coworkingSelector],
  coworking => coworking?.workplaces || null,
);
